// import React, { useEffect, useState } from 'react'
// import Header from '../Components/Header'
// import { createBrowserHistory } from 'history'

// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   PieChart,
//   Pie,
//   Cell,
// } from 'recharts'

// import StudentSdebar from './StudentSdebar'
// import axios from 'axios'
// import '../Styles/HoverCard.css'
// import { useNavigate } from 'react-router-dom'

// const history = createBrowserHistory()

// const Dashboard = () => {
//   const URL = 'https://kaasbackend.vetrinahealthcare.com/'

//   const handleNavigation = (path) => {
//     history.push(path)
//   }

//   const navigate = useNavigate()

//   const [statsData, setStatsData] = useState([{ label: '', value: 0 }])
//   const [graphData, setGraph] = useState([{ name: '', value: 0 }])
//   const [pieData, setPie] = useState([{ name: '', value: 0 }])
//   const COLORS = [
//     '#0088FE',
//     '#00C49F',
//     '#FFBB28',
//     '#FF8042',
//     '#845EC2',
//     '#D65DB1',
//     '#FF6F91',
//     '#2C73D2',
//   ]

//   useEffect(() => {
//     const token = localStorage.getItem('jwttoken')

//     if (!token) {
//       navigate('/')
//     }

//     axios
//       .get(`${URL}lms/dashboard`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         // console.log(response.data);
//         const stats = response.data.metrics
//         const grData = response.data.graph_data
//         const piData = response.data.pie_data

//         setGraph([...grData])
//         setStatsData([...stats])
//         setPie([...piData])
//       })
//       .catch((reason) => {
//         console.log(reason)
//       })
//   }, [])

//   return (
//     <div style={{ marginTop: '80px' }}>
//       <Header />
//       <div className='container-fluid'>
//         <div className='row Profile_info_row'></div>
//       </div>
//       <div
//         className='wrapper'
//         style={{
//           backgroundImage:
//             'linear-gradient(180.06deg, #E9F7FA 29.88%, #F8EEF5 58.49%)',
//         }}
//       >
//         <StudentSdebar />
//         <div className='main p-3' style={{ backgroundColor: 'transparent' }}>
//           <div
//             className='text-center border rounded mx-auto text-light mb-4 p-1'
//             style={{
//               background:
//                 'linear-gradient(to right, #3953A3, #7D52A0, #8852A0, #B8529E)',
//               width: '80%',
//               maxWidth: '350px',
//             }}
//           >
//             <h1 style={{ fontSize: '24px' }}>Welcome to Dashboard</h1>
//           </div>
//           <div className='row p-1 '>
//             <div className='col'>
//               <div className='row'>
//                 <div className='col-12 col-md-4 p-2 d-flex'>
//                   <button
//                     type='button'
//                     className='btn btn-custom-primary w-100'
//                     style={{ backgroundColor: '#D1B9E480' }}
//                   >
//                     GradesA+
//                   </button>
//                 </div>
//                 <div className='col-12 col-md-4 p-2 d-flex'>
//                   <button
//                     type='button'
//                     className='btn btn-custom-secondary w-100'
//                     style={{ backgroundColor: '#D1B9E480' }}
//                   >
//                     Achievement
//                   </button>
//                 </div>
//                 <div className='col-12 col-md-4 p-2 d-flex'>
//                   <button
//                     type='button'
//                     className='btn btn-custom-success w-100'
//                     style={{ backgroundColor: '#D1B9E480' }}
//                   >
//                     Basic
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className='row p-2'>
//             {statsData.map((data, index) => (
//               <div key={index} className='col-md-4 mb-4'>
//                 <div className='card hover-card'>
//                   <div className='card-body text-center'>
//                     <div className='pie-chart-container'>
//                       <h4>{data.value}</h4>
//                     </div>
//                     <div className='card-info mt-3'>
//                       <h6>{data.label}</h6>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <div className='row g-3 mt-3'>
//             {/* <div className="col-12 col-lg-6">
//               <div className="border border-primary rounded p-2">
//                 <h3 className="text-center">Revenue By Course</h3>
//                 <ResponsiveContainer width="100%" height={300}>
//                   <LineChart data={graphData}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="name" />
//                     <YAxis />
//                     <Tooltip />
//                     <Line type="monotone" dataKey="value" stroke="#8884d8" />
//                   </LineChart>
//                 </ResponsiveContainer>
//               </div>
//             </div> */}
//             <div className='col-12 d-flex justify-content-center'>
//               <div
//                 className='border border-primary rounded p-3'
//                 style={{ width: '100%', maxWidth: '600px' }}
//               >
//                 <h3 className='text-center'>Popular Courses</h3>
//                 <ResponsiveContainer width='100%' height={300}>
//                   <PieChart>
//                     <Tooltip />
//                     <Pie
//                       data={pieData}
//                       dataKey='value'
//                       nameKey='name'
//                       cx='50%'
//                       cy='50%'
//                       innerRadius={60}
//                       outerRadius={100}
//                       label
//                     >
//                       {pieData.map((entry, index) => (
//                         <Cell
//                           key={`cell-${index}`}
//                           fill={COLORS[index % COLORS.length]}
//                         />
//                       ))}
//                     </Pie>
//                     <Legend
//                       layout='horizontal'
//                       align='center'
//                       verticalAlign='bottom'
//                     />
//                   </PieChart>
//                 </ResponsiveContainer>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* <Footer /> */}
//     </div>
//   )
// }

// export default Dashboard
import React, { useEffect, useState } from 'react'
import Header from '../Components/Header'
import { createBrowserHistory } from 'history'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
} from 'recharts'
import StudentSdebar from './StudentSdebar'
import axios from 'axios'
import '../Styles/HoverCard.css'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'

const history = createBrowserHistory()

const Dashboard = () => {
  const URL = 'https://kaasbackend.vetrinahealthcare.com/'

  const navigate = useNavigate()
  const [statsData, setStatsData] = useState([])
  const [graphData, setGraph] = useState([])
  const [pieData, setPie] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [sidebarExpanded, setSidebarExpanded] = useState(true)

  const COLORS = [
    '#0088FE',
    '#00C49F',
    '#FFBB28',
    '#FF8042',
    '#845EC2',
    '#D65DB1',
    '#FF6F91',
    '#2C73D2',
  ]

  useEffect(() => {
    const token = localStorage.getItem('jwttoken')

    if (!token) {
      navigate('/')
    }

    axios
      .get(`${URL}lms/dashboard`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const stats = response.data.metrics
        const grData = response.data.graph_data
        const piData = response.data.pie_data

        setGraph([...grData])
        setStatsData([...stats])
        setPie([...piData])
        setIsLoading(false)
      })
      .catch((reason) => {
        console.log(reason)
        setIsLoading(false)
      })
  }, [])

  return (
    <div style={{ marginTop: '0px' }}>
      <Header />
      <div className="wrapper" style={{ display: "flex" }}>
        <StudentSdebar onToggle={setSidebarExpanded} />
    
        <motion.div
          className="main-content p-lg-4 p-md-3 p-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{
            marginTop: '60px',
            marginLeft: sidebarExpanded ? '240px' : '60px',
            transition: 'margin-left 0.25s ease-in-out',
            width: sidebarExpanded ? 'calc(100% - 240px)' : 'calc(100% - 60px)',
            overflowY: 'auto',
            height: 'calc(100vh - 60px)',
          }}
        >
          <div className='main p-3' style={{ backgroundColor: '#fff' }}>
            {isLoading ? (
              <div className='d-flex justify-content-center align-items-center' style={{ height: '80vh' }}>
                <div className='spinner-border text-primary' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {/* Welcome Header */}
                <div className='text-center border rounded mx-auto text-light mb-4 p-1'
                  style={{
                    background: 'linear-gradient(to right, #f4811e, #B8529E)',
                    width: '80%',
                    maxWidth: '350px'
                  }}>
                  <h1 style={{ fontSize: '24px' }}>Progress Section</h1>
                </div>

                {/* Info Buttons */}
                <div className='row p-1'>
                  <div className='col'>
                    <div className='row'>
                      <div className='col-12 col-md-4 p-2 d-flex'>
                        <button className='btn w-100 text-white' style={{ backgroundColor: '#f4811e', border: 'none' }}>
                          Grades A+
                        </button>
                      </div>
                      <div className='col-12 col-md-4 p-2 d-flex'>
                        <button className='btn w-100 text-white' style={{ backgroundColor: '#B8529E', border: 'none' }}>
                          Achievement
                        </button>
                      </div>
                      <div className='col-12 col-md-4 p-2 d-flex'>
                        <button className='btn w-100 text-white' style={{ backgroundColor: '#f4811e', border: 'none' }}>
                          Basic
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Stats Cards */}
                <div className='row p-2'>
                  {statsData.map((data, index) => (
                    <div key={index} className='col-md-4 mb-4'>
                      <div className='card hover-card'>
                        <div className='card-body text-center'>
                          <div className='pie-chart-container'>
                            <h4>{data.value}</h4>
                          </div>
                          <div className='card-info mt-3'>
                            <h6>{data.label}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Charts Row */}
                <div className='row g-3 mt-3'>
                  {/* Pie Chart */}
                  <div className='col-12 col-md-6 d-flex justify-content-center'>
                    <div className='border rounded p-3 w-100' style={{ borderColor: '#f4811e', maxWidth: '600px' }}>
                      <h5 className='text-center mb-3'>Popular Courses</h5>
                      <ResponsiveContainer width='100%' height={300}>
                        <PieChart>
                          <Tooltip />
                          <Pie
                            data={pieData}
                            dataKey='value'
                            nameKey='name'
                            cx='50%'
                            cy='50%'
                            innerRadius={60}
                            outerRadius={100}
                            label
                          >
                            {pieData.map((entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={COLORS[index % COLORS.length]}
                              />
                            ))}
                          </Pie>
                          <Legend layout='horizontal' align='center' verticalAlign='bottom' />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </div>

                  {/* Bar Chart */}
                  <div className='col-12 col-md-6 d-flex justify-content-center'>
                    <div className='border rounded p-3 w-100' style={{ borderColor: '#B8529E', maxWidth: '600px' }}>
                      <h5 className='text-center mb-3'>Monthly Activity</h5>
                      <ResponsiveContainer width='100%' height={300}>
                        <BarChart data={graphData}>
                          <CartesianGrid strokeDasharray='3 3' />
                          <XAxis dataKey='name' />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Bar dataKey='value' fill='#B8529E' />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default Dashboard
